import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord } from '@/app/guards';
import { InvoicePage, invoiceQuery } from '@/features/collections';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/collections/invoices/$invoiceId')({
  staticData: { crumb: 'collections:nav.invoices', crumbTo: '/collections/invoices' },
  loader: async ({ context, params }) => {
    const invoice = await ensureRecord(
      context.queryClient.query({ ...invoiceQuery(params.invoiceId), staleTime: 'static' }),
    );
    return { crumb: invoice.number };
  },
  notFoundComponent: function RecordNotFound() {
    const { invoiceId } = Route.useParams();
    return <NotFoundView reference={invoiceId} />;
  },
  component: function Invoice() {
    const { invoiceId } = Route.useParams();
    return <InvoicePage invoiceId={invoiceId} />;
  },
});
